
import React from 'react'

import { IGeneralData } from '@np/np_webcomponentlib'

import { optionEnum } from '../../shared/entityOperations/EntityFormTypes'

import { Column, ListFields } from '@np/np_webcomponentlib'

import { EntityFormProps } from '../../shared/entityOperations/EntityFormTypes'

import { ColumnWithCopyToClipboard } from '../../shared/entityOperations/EntityOperationsCustomFC'



import {EntityType as BusinessType} from '../Business/BusinessTypes'


// Interfaces
export interface IPaymentDetails {
  nameMediator?: string;
  paymentMethod?: string;
  bank?: string;
  number?: string;
  numberAdditional?: string;
  qRcode?: string;
}

export interface IIntegrationMerchantData {
  webHook?: string;
  redirectGeneralURL?: string;
  redirectSuccessURL?: string;
  redirectFailURL?: string;
}

export interface EntityType extends IPaymentDetails, IIntegrationMerchantData {
  [key: string]: string | number | Date | boolean | BusinessType | null | undefined ; // Допускаем, что значения могут быть строками или числами
  typeOperation: string;
  typeIntegration: string;
  status: string | number;
  idBusiness: string;  // UUID тип в TypeScript используется как string
  idTransactionMerchant: string;
  amount: number;

  amountInitial: number; // Изначальная сумма операции, которая может быть изменена в процессе обработки операции
  amountRandomized: number; // Сумма, которая может быть случайно изменена в процессе обработки операции
  
  amountComission: number;
  amountInCurrencyBalance: number;  
  currency: string;
  idProvider?: string;  // UUID тип в TypeScript используется как string
  idTansactionProvider?: string;
  amountComissionProvider: number;
  dateFinalCalculation?: Date;
  codeError: string;
  bankName: string;
  exchangeRate: number;

  exchangeRateForMerchant: number; // Курс обмена для мерчанта, который может отличаться от курса обмена для провайдера
  exchangeRateDifference: number;//Курсовая разница между нашим курсом и курсом провайдера

  exchangeRateForProvider: number; //Курс валюты, который используем для расчета суммы операции и комиссии в валюте баланса провайдера
  basis?: string;
  clientID?: string;
}

export enum TypeStatusEnum
{
  created,
  in_progress,
  success,
  failed,
  precreated,
  booking,
  pending_retry
}

export interface optionEnumTypeStatusEnum {
  value?:TypeStatusEnum
  label:string
  isDisabled?:any
}

export const optionsEnumStatusDoc: optionEnumTypeStatusEnum[] = [
  { value: undefined, label: 'Choose one', isDisabled: "true" },
  { value: TypeStatusEnum.created, label: 'Создана' },
  { value: TypeStatusEnum.in_progress, label: 'В обработке' },
  { value: TypeStatusEnum.success, label: 'Успешно' },
  { value: TypeStatusEnum.failed, label: 'С ошибкой' },
  { value: TypeStatusEnum.precreated, label: 'Предсоздана' },
  { value: TypeStatusEnum.booking, label: 'Бронирование' },
  { value: TypeStatusEnum.pending_retry, label: 'Ожидает retry' },
];


export interface DataEntityType extends IGeneralData, EntityType {
  businessAsProduct? : BusinessType;
  businessAsProvider? : BusinessType;
}

export interface DataEntityTypeViewModel {
  
}


//Расширенные данные для передачи сущности с предустановленными значениями для создания
export interface EntityFormPropsWithType extends EntityFormProps {
  initEntityProps: EntityType | undefined
}

// export const getEntityBylistVals = (listFields: ListFields[], entity: EntityType): EntityType => {
//   // Создаем новый объект на основе initEntity, чтобы не изменять оригинал
//   const updatedEntity: EntityType = { ...entity };

//   listFields.forEach(field => {
//     // Проверяем, существует ли такое поле в initEntity
//     if (field.fieldName in updatedEntity) {
//       // Устанавливаем первое значение из listVal, если оно существует
//       const valueToSet = field.listVal.length > 0 ? field.listVal[0] : '';
//       updatedEntity[field.fieldName] = valueToSet;
//     }
//   });

//   return updatedEntity;
// }


export const initEntity: EntityType = {
  typeOperation: "Purchase",
  typeIntegration: "Host2Host",
  status: "Pending",
  idBusiness: "b1234567-89ab-cdef-1234-56789abcdef0",
  idTransactionMerchant: "trans-merchant-001",
  amount: 1000.00,
  amountComission: 50.00,
  currency: "USD",
  amountComissionProvider: 30.00,
  codeError: "None",
  amountInCurrencyBalance: 0,
  bankName:"",
  exchangeRate: 0.00,
  exchangeRateForMerchant: 0.00,
  amountInitial: 0.00,
  amountRandomized: 0.00,
  exchangeRateDifference: 0.00,
  exchangeRateForProvider: 0.00

}




export const columnsIdrfspecification: Column[] = [

  {
    title: '',
    listFields: null,
    type: 'custom',
    custom: (data: DataEntityType) => (

      <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
    ),
    key: 1,
    withFilter: null,
    class: "eventColumn"
  },

  {
    title: 'Наименование',
    listFields: {
      fieldName: 'name',
      comparison: 'containsIgnoreCase',
      listVal: [''],
    },
    key: 5,
    withFilter: 'all',
  },




  {
    title: 'Дата создания',
    listFields: {
      fieldName: 'dateAdded',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 100,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },


  {
    title: 'Дата изменения',
    listFields: {
      fieldName: 'dateUpdated',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 101,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },



]




export const columnsForChoise: Column[] = [

  {
    title: '',
    listFields: null,
    type: 'custom',
    custom: (data: DataEntityType) => (

      <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
    ),
    key: 1,
    withFilter: null,
    class: "eventColumn"
  },


  {
    title: 'Наименование',
    listFields: {
      fieldName: 'name',
      comparison: 'containsIgnoreCase',
      listVal: [''],
    },
    key: 6,
    withFilter: 'all',
  },




  {
    title: 'Дата создания',
    listFields: {
      fieldName: 'dateAdded',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 100,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },


  {
    title: 'Дата изменения',
    listFields: {
      fieldName: 'dateUpdated',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 101,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },



]



export const columnsIdrfcharacteristictype: Column[] = [

  {
    title: '',
    listFields: null,
    type: 'custom',
    custom: (data: DataEntityType) => (

      <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
    ),
    key: 1,
    withFilter: null,
    class: "eventColumn"
  },


  {
    title: 'Наименование',
    listFields: {
      fieldName: 'name',
      comparison: 'containsIgnoreCase',
      listVal: [''],
    },
    key: 6,
    withFilter: 'all',
  },




  {
    title: 'Дата создания',
    listFields: {
      fieldName: 'dateAdded',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 100,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },


  {
    title: 'Дата изменения',
    listFields: {
      fieldName: 'dateUpdated',
      comparison: 'containsStrong',
      listVal: [''],
    },
    type: 'date-time',
    key: 101,
    withFilter: 'onlySorted',
    class: "dateTtimeColumn"
  },



]




// Функция для форматирования даты
const formatDate = (dateString: string): string => {
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);
  return `${day}.${month}.${year}`;
};

// Функция для форматирования времени
const formatTime = (timeString: string): string => {
  // Предполагаем, что timeString в формате "hhmm"
  const hours = timeString.substring(0, 2);
  const minutes = timeString.substring(2, 4);
  return `${hours}:${minutes}`;
};



// Преобразует числовой статус в строковое имя enum
export const getStatusString = (status: string | number): string => {
  if (typeof status === 'number') {
    return TypeStatusEnum[status] || String(status);
  }
  return status;
};

interface PropsDisplayStatusDoc {
  statusDoc: string | number
  providerID: string | undefined
}


export const DisplayStatusDoc: React.FC<PropsDisplayStatusDoc> = ({ statusDoc, providerID }) => {
  const status = getStatusString(statusDoc);
  return (
    <div>
      {status === 'success' &&
        <button className="btn btn-success btn-sm" style={{ width: '100px' }}>Успешно</button>
      }

      {status === 'created' &&
        <button className="btn btn-secondary btn-sm" style={{ width: '100px' }}>Создан</button>
      }

      {status === 'in_progress' &&
        <button className="btn btn-primary btn-sm" style={{ width: '100px' }}>В обработке</button>
      }

      {status === 'failed' && providerID && providerID !== "" &&
        <button className="btn btn-danger btn-sm" style={{ width: '100px' }}>С ошибкой</button>
      }

      {status === 'failed' && (!providerID || providerID === "") &&
        <button className="btn btn-warning btn-sm" style={{ width: '100px' }}>Нет ревизитов</button>
      }

      {status === 'pending_retry' &&
        <button className="btn btn-warning btn-sm" style={{ width: '100px' }}>Retry</button>
      }

      {status === 'precreated' &&
        <button className="btn btn-info btn-sm" style={{ width: '100px' }}>Предсоздан</button>
      }

      {status === 'booking' &&
        <button className="btn btn-info btn-sm" style={{ width: '100px' }}>Бронь</button>
      }

    </div>
  );
};

